import { DataBean } from "../../DataBean";


export class ConsecutiveByUBLSoftwareDispatcher extends DataBean {

    public async getTaxEntityConsecutiveByUBLSoftwareDispatcher(idUBLSoftwareDispatcher: any, ublDocumentType: any, date: any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "java.util.List_getTaxEntityConsecutiveByUBLSoftwareDispatcher_Number_Number_java.util.Date", [idUBLSoftwareDispatcher, ublDocumentType, date]);
    }

}